module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-modal",
    attrs: {
      "id": "crearusuaris-modal"
    }
  }, [_c('div', {
    staticClass: "dismiss",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("close")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "crearusuaris-modal-body"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('title')) + " \n        "), _vm._m(0), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.mapa.nomAplicacio) + "\n    ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('message')))]), _vm._v(" "), _c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.numAlumnes),
      expression: "form.numAlumnes"
    }],
    staticClass: "form-control my-border",
    attrs: {
      "lang": "ca",
      "id": "numAlumnes",
      "name": "numAlumnes",
      "type": "text",
      "placeholder": _vm.$t('numUsuarisPlaceholder')
    },
    domProps: {
      "value": (_vm.form.numAlumnes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "numAlumnes", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('nota')))]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.crearUsersMapa
    }
  }, [_vm._v(_vm._s(_vm.$t('crear_usuaris')))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "crearusuaris-modal-msg"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('notaEsperar')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('a', {
    staticClass: "faqs_link",
    attrs: {
      "href": "https://betaportal.icgc.cat/wordpress/faq-dinstamaps/#didactic",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-question-sign faq-icon"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9da6328"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/perfil/components/crearusuaris-modal/crearusuaris-modal.vue
// module id = 323
// module chunks = 0